import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-floppy-icon',
  imports: [],
  templateUrl: './floppy-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './floppy-icon.component.scss',
})
export class FloppyIconComponent {}
